import React from 'react';
import { cn } from '../../lib/cn';

export default function SectionHeading({ step, title, hint, action, className }) {
  return (
    <div className={cn('flex items-center justify-between gap-3', className)}>
      <div className="flex items-center gap-2.5 min-w-0">
        {step != null ? (
          <span className="h-6 w-6 rounded-md bg-brand-50 text-brand-700 text-[11px] font-semibold border border-brand-100 inline-flex items-center justify-center shrink-0">
            {step}
          </span>
        ) : null}
        <div className="min-w-0">
          <p className="text-[13px] font-semibold text-slate-800 truncate">{title}</p>
          {hint ? <p className="text-[11.5px] text-slate-500 mt-0.5 truncate">{hint}</p> : null}
        </div>
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}
